import { Fade } from 'react-reveal';
import style from './SectionTitle.module.scss';
import { useRef } from 'react';
import { useIntersectionObserver } from 'usehooks-ts';

const SectionTitle = ({ children, className, small }) => {
  const ref = useRef(null);
  const entry = useIntersectionObserver(ref, {});
  const isVisible = !!entry?.isIntersecting;

  return (
    <div ref={ref}>
      <Fade spy={isVisible} bottom>
        <div className={`${style.title} ${small && style.small} ${className}`}>
          {children}
        </div>
      </Fade>
    </div>
  );
};

export default SectionTitle;
